import React from 'react'
import { useTranslation } from 'react-i18next'
import { RegistrationMethod } from './Registration'
import styles from './Registration.module.css'
import { AppleSignInButton } from '../../components/apple-signin-button/AppleSignInButton'
import { GoogleSignInButton } from '../../components/google-signin-button/GoogleSignInButton'
import { Box } from '@mui/material'

type Props = {
  userData: {
    firstName: string
    lastName: string
    email: string
  } | null
  error: string | null
  token: string
  onSelectMethod: (method: RegistrationMethod, data?: any) => void
}

export function RegistrationMethodSelector({ userData, error, token, onSelectMethod }: Props) {
  const { t } = useTranslation()

  const handleGoogleSuccess = (response: any) => {
    onSelectMethod('google', {
      user: response,
      registrationComplete: true,
    })
  }

  const handleAppleSuccess = (response: any) => {
    onSelectMethod('apple', {
      user: response,
      registrationComplete: true,
    })
  }

  const handleGoogleError = (error: any) => {
    console.error('Google Sign In Error:', error)
  }

  const handleAppleError = (error: any) => {
    console.error('Apple Sign In Error:', error)
  }

  return (
    <Box className={styles.containerForm}>
      <Box className={styles.registrationContainer}>
        <h4 className={styles.registrationTitle}>{t('completeRegistration')}</h4>
        <hr className={styles.divider} />
        {error && <Box className={styles.errorAlert}>{error}</Box>}

        {userData && (
          <Box className={styles.userInfoAlert}>
            {t('welcome')} {userData.firstName} {userData.lastName}
          </Box>
        )}

        <h5 className={styles.methodTitle}>{t('chooseRegistrationMethod')}</h5>

        <Box className={styles.methodsContainer}>
          <button className={styles.emailMethodButton} onClick={() => onSelectMethod('email')}>
            {t('registrationEmailPassword')}
          </button>
          <p className={styles.or}>{t('o')}</p>
          <Box style={{ width: '100%' }}>
            <GoogleSignInButton
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              label={t('registrationGoogle')}
              token={token}
            />
          </Box>

          <Box style={{ width: '100%' }}>
            <AppleSignInButton
              onSuccess={handleAppleSuccess}
              onError={handleAppleError}
              label={t('registrationApple')}
              token={token}
              mode="registration"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
